import { FileText } from 'lucide-react'
import { Badge } from '@/components/ds2'
import { ATTACHED_NOTE, attachedOf } from './uploads/chatAttachments'
import { visibleText } from './uploads/untrustedText'

/**
 * The user's message in the thread (v17): the typed words in the light accent bubble, and, for a message that carried documents, the
 * file list with each name marked Unverified and the note on what our check reads from them. What the uploads told the agent stays out
 * of the bubble, and so does the data note on a file name.
 */
export const UserBubble = ({ content }: { content: string }) => {
    const { text, files } = attachedOf(content)
    const shown = visibleText(text)
    return (
        // The thread brings the newest user message into view by this mark (`USER_MESSAGE_ATTRIBUTE`).
        <li
            data-user-message=""
            className="ml-auto flex max-w-[85%] flex-col gap-2 rounded-2xl rounded-br-sm bg-accent-soft px-4 py-2.5 text-sm text-foreground"
        >
            {shown && <span className="whitespace-pre-wrap">{shown}</span>}
            {files.length > 0 && (
                <div className="flex flex-col gap-1.5">
                    <ul aria-label="Attached documents" className="flex flex-col gap-1">
                        {files.map((name) => (
                            <li key={name} className="flex items-center gap-2">
                                <FileText className="h-3.5 w-3.5 shrink-0 text-foreground-muted" aria-hidden />
                                <span className="min-w-0 flex-1 truncate">{name}</span>
                                <Badge type="warning" label="Unverified" />
                            </li>
                        ))}
                    </ul>
                    <p className="text-xs text-foreground-muted">{ATTACHED_NOTE}</p>
                </div>
            )}
        </li>
    )
}
